import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import '../home/home.css'
import { Link, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import apiRequest, { FILE_PATH } from "../../../api/api.js";
export const BASEURL = process.env.REACT_APP_BASE_URL_ROOT;

export default function Home() {
    const location = useLocation();
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
    };
    const [banners, setBanners] = useState([]);
    const [faq, setFaq] = useState([]);
    const [quiz, setQuiz] = useState([]);
    const [visibleFaqs, setVisibleFaqs] = useState(5);


    const cardClasses = [
        "math-card",
        "science-card",
        "language-card",
        "social-card"
    ];

    const btnClasses = [
        "registration-btn-blue",
        "registration-btn-green",
        "registration-btn-purple",
        "registration-btn-blue"
    ];

    useEffect(() => {
        if (location.hash) {
            setTimeout(() => {
                const element = document.querySelector(location.hash);

                if (element) {
                    const navbarHeight = 87; // closed header height

                    const y =
                        element.getBoundingClientRect().top +
                        window.pageYOffset -
                        navbarHeight;

                    window.scrollTo({
                        top: y,
                        behavior: "smooth",
                    });
                }
            }, 300);
        }
    }, [location]);

    useEffect(() => {
        fetchBanners();
    }, []);

    useEffect(() => {
        fetchFaq();
    }, []);

    useEffect(() => {
        fetchQuiz();
    }, []);

    const fetchBanners = async () => {
        try {
            const data = await apiRequest.get("/banner");
            console.log('banner', data);
            setBanners(data.data || data);
        } catch (error) {
        }
    };

    const fetchFaq = async () => {
        try {
            const data = await apiRequest.get("/faqs");
            console.log("faq", data);

            setFaq(data.data || []);
        } catch (error) {
            console.error(error);
        }
    };


    const fetchQuiz = async () => {
        try {
            const data = await apiRequest.get("/quiz");
            console.log("quiz", data);

            setQuiz(data.data || []);
        } catch (error) {
            console.error(error);
        }
    };



    return (
        <div className="main">
            <div className="hero-banner">
                {banners.length > 0 && (
                    <Slider {...settings}>
                        {banners.map((banner, index) => (
                            <div className="hero-single-slide" key={index}>
                                <Link
                                    to={`/quiz/${banner.quiz}`}
                                    className="d-block h-100"
                                >
                                    <picture>
                                        {/* Mobile */}
                                        <source
                                            media="(max-width: 767px)"
                                            srcSet={`${FILE_PATH}${banner.mobile}`}
                                        />

                                        {/* Tablet */}
                                        <source
                                            media="(max-width: 1024px)"
                                            srcSet={`${FILE_PATH}${banner.tablet}`}
                                        />

                                        {/* Desktop */}
                                        <img
                                            src={`${FILE_PATH}${banner.desktop}`}
                                            alt={banner.title || "Banner"}
                                            style={{ width: "100%" }}
                                        />
                                    </picture>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
            <section className="volt-section" id="volt-section">
                <div className="container">
                    <div className="text-center">
                        <h1 className="section-title">Why VOLT Learning?</h1>
                        <p className="section-subtitle">
                            VOLT Learning is an innovative educational platform that empowers students through engaging assessments, interactive quizzes, and skill-based learning experiences. It helps learners strengthen concepts, develop critical thinking, and build confidence for future success.
                        </p>
                    </div>
                    <div className="row g-4">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="feature-card">
                                <div className="icon-wrapper icon-blue">
                                    <img src={BASEURL + "assets/images/Interactive.png"} alt="Skills"
                                    />
                                </div>
                                <h3 className="feature-title">Interactive<br />Assessments</h3>
                                <p className="feature-description">Designed to make learning engaging and meaningful.</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="feature-card">
                                <div className="icon-wrapper icon-green">
                                    <img src={BASEURL + "assets/images/Skill.png"} alt="Skills" />
                                </div>
                                <h3 className="feature-title">Skill<br />Building</h3>
                                <p className="feature-description">Develop analytical and problem-solving skills.</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="feature-card">
                                <div className="icon-wrapper icon-yellow">
                                    <img src={BASEURL + "assets/images/Concept.png"} alt="Skills" />
                                </div>
                                <h3 className="feature-title">Concept<br />Reinforcement</h3>
                                <p className="feature-description">Strengthen concepts across multiple domains.</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="feature-card">
                                <div className="icon-wrapper icon-pink">
                                    <img src={BASEURL + "assets/images/Digital_Learning.png"} alt="Skills" />
                                </div>
                                <h3 className="feature-title">Digital Learning<br />Experience</h3>
                                <p className="feature-description">A modern, secure, and student-friendly digital learning experience.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="quiz-categories">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="section-title fw-bold mb-3">
                            Explore Quiz Categories
                        </h2>

                        <p className="section-description mx-auto">
                            {/* VOLT Learning is a fun and interactive educational platform that helps
                            students strengthen concepts through quizzes, challenges, and skill-based activities. */}
                            Choose from a variety of engaging quiz categories designed to help students learn, think and grow.
                        </p>
                    </div>

                    <div className="row g-4 justify-content-center">
                        {quiz?.map((item, index) => (
                            <div className="col-12 col-sm-6 col-lg-3" key={item.id}>
                                <div className={`category-card ${cardClasses[index % 4]} h-100 text-center`} >

                                    <div className="category-image mb-3">
                                        <img
                                            src={`${FILE_PATH}${item.icon}`}
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </div>

                                    <h3 className="category-title">
                                        {item.title}
                                    </h3>

                                    {item.registration ? (
                                        <a
                                            href={`/quiz/${item.slug}`}
                                            rel="noopener noreferrer"
                                            className={`btn registration-btn ${btnClasses[index % 4]}`}
                                        >
                                            Registration Open
                                        </a>
                                    ) : (
                                        <button className="btn coming-soon-btn">
                                            Coming Soon
                                        </button>
                                    )}

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="assessment-section py-5 overflow-hidden" id="Assessment-Format">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="assessment-title fw-bold mb-3">
                            Assessment Format
                        </h2>

                        <p className="assessment-description mx-auto mb-0">
                            The assessment includes a variety of question types designed to evaluate conceptual understanding, critical thinking, and problem-solving skills.
                        </p>
                    </div>

                    <div className="row align-items-center gy-5">

                        <div className="col-lg-7">

                            <div className="row gy-5">

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-3 assessment-item">

                                        <div className="assessment-icon">
                                            <img src={BASEURL + "assets/images/Multiple.png"}
                                                alt="MCQ"
                                                className="img-fluid" />
                                        </div>

                                        <div>
                                            <h3 className="assessment-heading mb-1">
                                                Multiple Choice
                                            </h3>

                                            <p className="assessment-subtitle mb-0">
                                                Questions
                                            </p>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-3 assessment-item">

                                        <div className="assessment-icon">
                                            <img src={BASEURL + "assets/images/Visual-Interpretation.png"}
                                                alt="Visual"
                                                className="img-fluid" />
                                        </div>

                                        <div>
                                            <h3 className="assessment-heading mb-1">
                                                Visual Interpretation
                                            </h3>

                                            <p className="assessment-subtitle mb-0">
                                                Questions
                                            </p>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-3 assessment-item">

                                        <div className="assessment-icon">
                                            <img src={BASEURL + "assets/images/Concept-Based.png"}
                                                alt="Concept"
                                                className="img-fluid" />
                                        </div>

                                        <div>
                                            <h3 className="assessment-heading mb-1">
                                                Concept-Based
                                            </h3>

                                            <p className="assessment-subtitle mb-0">
                                                Questions
                                            </p>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-3 assessment-item">

                                        <div className="assessment-icon">
                                            <img src={BASEURL + "assets/images/Logical-Reasoning.png"}
                                                alt="Logical"
                                                className="img-fluid" />
                                        </div>

                                        <div>
                                            <h3 className="assessment-heading mb-1">
                                                Logical Reasoning
                                            </h3>

                                            <p className="assessment-subtitle mb-0">
                                                Challenges
                                            </p>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-3 assessment-item">

                                        <div className="assessment-icon">
                                            <img src={BASEURL + "assets/images/Application-Based.png"}
                                                alt="Application"
                                                className="img-fluid" />
                                        </div>

                                        <div>
                                            <h3 className="assessment-heading mb-1">
                                                Application-Based
                                            </h3>

                                            <p className="assessment-subtitle mb-0">
                                                Questions
                                            </p>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-3 assessment-item">

                                        <div className="assessment-icon">
                                            <img src={BASEURL + "assets/images/General-Awareness.png"}
                                                alt="General"
                                                className="img-fluid" />
                                        </div>

                                        <div>
                                            <h3 className="assessment-heading mb-1">
                                                Analytical Thinking
                                            </h3>

                                            <p className="assessment-subtitle mb-0">
                                                Questions
                                            </p>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-lg-5 text-center d-none d-lg-block">

                            <img src={BASEURL + "assets/images/laptop.png"}
                                alt="Assessment"
                                className="img-fluid assessment-laptop" />

                        </div>

                    </div>

                </div>
            </section>
            <section className="rewards-section" id="reward">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="section-title fw-bold mb-3">
                            Recognition & Rewards
                        </h2>

                        <p className="section-description mx-auto mb-0">
                            We celebrate every learner's achievement and encourage continuous improvement.
                        </p>
                    </div>

                    <div className="row justify-content-center g-4">
                        <div className="col-12 col-md-6 col-lg-4">

                            <div className="reward-card reward-card-teal position-relative h-100 text-center">

                                <span className="reward-number reward-number-teal">
                                    01
                                </span>

                                <div className="reward-top reward-top-teal">
                                    <img src={BASEURL + "assets/images/School-Level.png"}
                                        alt="School Recognition"
                                        className="img-fluid reward-main-image my-2" />
                                </div>

                                <div className="reward-icon reward-icon-teal d-flex justify-content-center align-items-center">
                                    <img src={BASEURL + "assets/images/school.png"}
                                        alt=""
                                        className="img-fluid" />
                                </div>

                                <div className="reward-content px-4 pb-4">

                                    <h3 className="reward-title">
                                        School-Level <br />
                                        Recognition
                                    </h3>

                                    <div className="reward-divider reward-divider-teal mx-auto"></div>

                                    <p className="reward-description mb-0">
                                        Outstanding performers will be recognised at the school level for their academic excellence.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div className="col-12 col-md-6 col-lg-4">

                            <div className="reward-card reward-card-orange position-relative h-100 text-center">

                                <span className="reward-number reward-number-orange">
                                    02
                                </span>

                                <div className="reward-top reward-top-orange d-flex justify-content-center align-items-center">
                                    <img src={BASEURL + "assets/images/Exciting-Gifts.png"}
                                        alt="Gift"
                                        className="img-fluid reward-main-image my-2" />
                                </div>

                                <div className="reward-icon reward-icon-orange">
                                    <img src={BASEURL + "assets/images/gift-box-with-a-bow.png"}
                                        alt=""
                                        className="img-fluid" />
                                </div>

                                <div className="reward-content px-4 pb-4">

                                    <h3 className="reward-title">
                                        Exciting Gifts <br />
                                        for Winners
                                    </h3>

                                    <div className="reward-divider reward-divider-orange mx-auto"></div>

                                    <p className="reward-description mb-0">
                                        Top-performing students will receive exciting gifts and recognition for their outstanding performance.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div className="col-12 col-md-6 col-lg-4">

                            <div className="reward-card reward-card-purple position-relative h-100 text-center">

                                <span className="reward-number reward-number-purple d-flex justify-content-center align-items-center">
                                    03
                                </span>

                                <div className="reward-top reward-top-purple">
                                    <img src={BASEURL + "assets/images/Digital-Participation.png"}
                                        alt="Certificate"
                                        className="img-fluid reward-main-image my-2" />
                                </div>

                                <div className="reward-icon reward-icon-purple">
                                    <img src={BASEURL + "assets/images/certificate.png"}
                                        alt=""
                                        className="img-fluid" />
                                </div>

                                <div className="reward-content px-4 pb-4">

                                    <h3 className="reward-title">
                                        Participation<br />
                                        Certificates
                                    </h3>

                                    <div className="reward-divider reward-divider-purple mx-auto"></div>

                                    <p className="reward-description mb-1">
                                        Every participant will receive a certificate of completion.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
            <section className="how-it-works-section py-5" id="how-it-works-section">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="how-title fw-bold mb-3">
                            How It Works
                        </h2>

                        <p className="how-description mx-auto">
                            Start your learning journey in 4 easy steps
                        </p>
                    </div>

                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                            <div className="step-card step-card-blue text-center position-relative h-100">

                                <div className="step-number step-number-blue">
                                    01
                                </div>

                                <img src={BASEURL + "assets/images/Register.png"}
                                    className="img-fluid step-image"
                                    alt="Register" />

                                <h3 className="step-title">
                                    Register
                                </h3>

                                <div className="step-divider step-divider-blue mx-auto"></div>

                                <p className="step-description mb-0">
                                    Complete the simple online registration process.
                                </p>

                                <div className="step-arrow step-arrow-blue d-none d-lg-flex">
                                    <span>&#8250;</span>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                            <div className="step-card step-card-green text-center position-relative h-100">

                                <div className="step-number step-number-green">
                                    02
                                </div>

                                <img src={BASEURL + "assets/images/Get-Access.png"}
                                    className="img-fluid step-image"
                                    alt="Access" />

                                <h3 className="step-title">
                                    Get Access
                                </h3>

                                <div className="step-divider step-divider-green mx-auto"></div>

                                <p className="step-description mb-0">
                                    Receive login credentials and assessment instructions.
                                </p>

                                <div className="step-arrow step-arrow-green d-none d-lg-flex">
                                    <span>&#8250;</span>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                            <div className="step-card step-card-orange text-center position-relative h-100">

                                <div className="step-number step-number-orange">
                                    03
                                </div>

                                <img src={BASEURL + "assets/images/Take-the-Assessment.png"}
                                    className="img-fluid step-image"
                                    alt="Assessment" />

                                <h3 className="step-title">
                                    Take the Assessment
                                </h3>

                                <div className="step-divider step-divider-orange mx-auto"></div>

                                <p className="step-description mb-0">
                                    Attempt the quiz within the scheduled time window.
                                </p>

                                <div className="step-arrow step-arrow-orange d-none d-lg-flex">
                                    <span>&#8250;</span>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                            <div className="step-card step-card-purple text-center position-relative h-100">

                                <div className="step-number step-number-purple">
                                    04
                                </div>

                                <img src={BASEURL + "assets/images/Recognition.png"}
                                    className="img-fluid step-image"
                                    alt="Recognition" />

                                <h3 className="step-title">
                                    Recognition
                                </h3>

                                <div className="step-divider step-divider-purple mx-auto"></div>

                                <p className="step-description mb-0">
                                    Receive certificate and winner announcements from your school.
                                </p>

                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <section className="experts-section">
                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-5 text-center">

                            <div className="expert-image-wrapper mx-auto">
                                <img
                                    src="assets/images/mam.png"
                                    alt="Education Expert"
                                    className="img-fluid expert-image" />
                            </div>

                        </div>


                        <div className="col-lg-7">

                            <div className="mb-5">
                                <h2 className="expert-title fw-bold mb-3">
                                    Designed by Education Experts
                                </h2>

                                <p className="expert-description mb-0">
                                    Our assessments are carefully crafted by experienced educators
                                    to ensure quality learning outcomes.
                                </p>
                            </div>

                            <div className="row g-4">

                                <div className="col-md-6">
                                    <div className="expert-card expert-card-blue d-flex align-items-center">

                                        <div className="expert-icon expert-icon-blue">
                                            <img src={BASEURL + "assets/images/graduate-hat.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3">
                                            <h4 className="expert-card-title mb-2">
                                                Middle School <br />
                                                Educator
                                            </h4>

                                            <div className="expert-divider expert-divider-blue"></div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="expert-card expert-card-green d-flex align-items-center">

                                        <div className="expert-icon expert-icon-green">
                                            <img src={BASEURL + "assets/images/book.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3">
                                            <h4 className="expert-card-title mb-2">
                                                Subject <br />
                                                Expert
                                            </h4>

                                            <div className="expert-divider expert-divider-green"></div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="expert-card expert-card-orange d-flex align-items-center">

                                        <div className="expert-icon expert-icon-orange">
                                            <img src={BASEURL + "assets/images/specialist.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3">
                                            <h4 className="expert-card-title mb-2">
                                                Assessment <br />
                                                Specialist
                                            </h4>

                                            <div className="expert-divider expert-divider-orange"></div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="expert-card expert-card-purple d-flex align-items-center">

                                        <div className="expert-icon expert-icon-purple">
                                            <img src={BASEURL + "assets/images/portal.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3">
                                            <h4 className="expert-card-title mb-2">
                                                Digital Learning <br />
                                                Consulted
                                            </h4>

                                            <div className="expert-divider expert-divider-purple"></div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
            <section className="faq-section py-5" id="faq">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="faq-title fw-bold mb-3">
                            Frequently Asked Questions
                        </h2>

                        <p className="faq-description mx-auto mb-0">
                            VOLT Learning is a fun and interactive educational platform that helps
                            students strengthen concepts through quizzes, challenges, and skill-based activities.
                        </p>
                    </div>

                    <div className="accordion custom-faq mx-auto" id="faqAccordion">
                        {faq?.slice(0, visibleFaqs).map((item, index) => (
                            <div
                                className="accordion-item faq-item border-0 mb-4"
                                key={item.id}
                            >
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button faq-button ${index !== 0 ? "collapsed" : ""
                                            }`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#faq${item.id}`}
                                        aria-expanded={index === 0}
                                        aria-controls={`faq${item.id}`}
                                    >
                                        <span className="faq-icon me-3">
                                            <img
                                                src="assets/images/faq.svg"
                                                alt="FAQ"
                                            />
                                        </span>

                                        <span>{item.question}</span>
                                    </button>
                                </h2>

                                <div
                                    id={`faq${item.id}`}
                                    className={`accordion-collapse collapse ${index === 0 ? "show" : ""
                                        }`}
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div
                                        className="accordion-body faq-body"
                                        dangerouslySetInnerHTML={{
                                            __html: item.answer,
                                        }}
                                    />
                                </div>
                            </div>
                        ))}

                        {faq?.length > 5 && (
                            <div className="text-center mt-4">
                                {visibleFaqs < faq.length ? (
                                    <button
                                        className="btn-accordian"
                                        onClick={() =>
                                            setVisibleFaqs((prev) => prev + 5)
                                        }
                                    >
                                        View More
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setVisibleFaqs(5)}
                                    >
                                        View Less
                                    </button>
                                )}
                            </div>
                        )}

                        {faq?.length === 0 && (
                            <div className="text-center">
                                <p>No FAQs available</p>
                            </div>
                        )}
                    </div>

                </div>
            </section>
            <section className="cta-section py-5">
                <div className="container">

                    <div className="cta-wrapper position-relative overflow-hidden">

                        <div className="row align-items-center g-4">

                            <div className="col-lg-3 col-md-4 text-center">

                                <img
                                    src="assets/images/award.png"
                                    alt="Trophy"
                                    className="img-fluid cta-image" />

                            </div>

                            <div className="col-lg-6 col-md-8">

                                <h2 className="cta-title fw-bold mb-3">
                                    Ready to Begin the <br />
                                    learning Journey?
                                </h2>

                                <p className="cta-description mb-4">
                                    Take the next step towards knowledge,
                                    confidence and growth.
                                </p>

                                <a href="#"
                                    className="btn cta-btn d-inline-flex align-items-center">
                                    Explore Now
                                    <span className="ms-2">›</span>
                                </a>

                            </div>

                            <div className="col-lg-3 d-none d-lg-block text-end">

                                <div className="paper-plane-wrapper">
                                    <img
                                        src="assets/images/flying_paper.svg"
                                        alt="Paper Plane"
                                        className="img-fluid paper-plane" />
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
        </div>
    );
}